import { GET_STATE_LIST } from './ApiConstants';
import api from './ApiHandler';

export const getStates = async (payload: any) => {
  return await api.get(GET_STATE_LIST, { params: payload });
};
